import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.177 3A3.411 3.411 0 0 1 17 7.822l-.948.948-.001.001-.001.001-9.014 9.014a.73.73 0 0 1-.514.213H2.727A.727.727 0 0 1 2 17.273v-3.796c0-.193.077-.378.213-.514zm-.435 2.49-8.287 8.288v2.768h2.767l8.287-8.288zm3.796 1.74L12.77 4.461l.434-.434a1.957 1.957 0 1 1 2.767 2.767z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }